<template>
  <section id="all-emr-insurances" class="all-cases-view" v-loading="loading">
    <div class="container-small-table">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="24">
            <ul class="d-flex flex-wrap justify-content-end list-items-group-15">
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Search"
                    v-model="search_string"
                    @input="onSearch"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="primary-content-view-new">
        <el-tabs v-model="activeTab" @tab-click="onTabChange">
          <!-- Unmapped Tab -->
          <el-tab-pane label="New Emr Insurance" name="unmapped">
            <div class="listings listings__table listings__all-cases" id="unmapped-listings">
              <el-table
                :data="getEMRInsurances.data"
                height="calc(100vh - 260px)"
              >
                <el-table-column label="INSURANCE NAME" min-width="250">
                  <template v-slot="scope">
                    {{ scope.row.insurance_name || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="Example Order Id" min-width="250">
                  <template v-slot="scope">
                    {{ scope.row.order_id || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="STATUS" min-width="120">
                  <template v-slot>
                    <el-tag type="warning">Not Mapped</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="ACTIONS" width="100">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li>
                        <el-button
                          class="view-button"
                          title="Map Insurance"
                          @click="openMapDialog(scope.row)"
                        >
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/edit-active.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/edit-deactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- Mapped Tab -->
          <el-tab-pane label="Mapped to lis insurance payor" name="mapped">
            <div class="listings listings__table listings__all-cases" id="mapped-listings">
              <el-table
                :data="getEMRInsurances.data"
                height="calc(100vh - 260px)"
              >
                <el-table-column label="INSURANCE NAME" min-width="200">
                  <template v-slot="scope">
                    {{ scope.row.insurance_name || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="MAPPED TO" min-width="200">
                  <template v-slot="scope">
                    {{ scope.row.mapped_insurance_name || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="CARRIER CODE" min-width="130">
                  <template v-slot="scope">
                    {{ scope.row.carrier_code || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="WAVELAND CODE" min-width="150">
                  <template v-slot="scope">
                    {{ scope.row.waveland_verification_code || "--" }}
                  </template>
                </el-table-column>
                <el-table-column label="ACTIONS" width="110">
                  <template v-slot="scope">
                    <ul class="listings__action-buttons">
                      <li>
                        <el-button
                          class="view-button"
                          title="Edit"
                          @click="openMapDialog(scope.row)"
                        >
                          <img
                            class="action-active"
                            src="@/assets/images/icons/actions/edit-active.svg"
                            alt="icon"
                          />
                          <img
                            class="action-inactive"
                            src="@/assets/images/icons/actions/edit-deactive.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                      <li>
                        <el-button
                          class="view-button"
                          title="Delete"
                          @click="deleteRecord(scope.row._id)"
                        >
                          <img
                            class="testreports-active"
                            src="@/assets/images/icons/actions/test-delect-active.svg"
                            alt="icon"
                          />
                        </el-button>
                      </li>
                    </ul>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="listings listings__pagination">
        <el-pagination
          v-model:currentPage="page"
          v-model:page-size="pageSize"
          :page-sizes="[25, 50, 75, 100]"
          layout="prev, pager, next, jumper, sizes, total"
          :total="getEMRInsurances.total || 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- Map / Edit Dialog -->
    <el-dialog
      v-model="showMapDialog"
      :title="selectedRecord && selectedRecord.is_not_mapped ? 'Map Insurance' : 'Edit Insurance Mapping'"
      width="500px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form :model="formData" label-position="top">
        <el-form-item label="EMR Insurance Name">
          <el-input v-model="formData.insurance_name" disabled />
        </el-form-item>
        <el-form-item label="Map to Lis Insurance Payor" required>
          <el-select
            v-model="formData.mapped_insurance_name"
            filterable
            remote
            :remote-method="searchPayors"
            :loading="payorsLoading"
            placeholder="Search insurance payor..."
            style="width: 100%"
            @change="onPayorSelect"
          >
            <el-option
              v-for="(item, index) in getAllPayors && getAllPayors.data || []"
              :key="index"
              :label="item.name"
              :value="item.name"
              :data-payor="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Carrier Code" required>
          <el-input v-model="formData.carrier_code" placeholder="Auto-filled from payor" />
        </el-form-item>
        <el-form-item label="Waveland Verification Code" required>
          <el-input
            v-model="formData.waveland_verification_code"
            placeholder="Enter waveland verification code"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showMapDialog = false">Cancel</el-button>
        <el-button
          type="primary"
          :disabled="!formData.mapped_insurance_name"
          :loading="saving"
          @click="saveMapping"
        >
          Save
        </el-button>
      </template>
    </el-dialog>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper"
import FilterHelper from "@/mixins/FilterHelper"
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications"

export default {
  mixins: [UserPermissionsHelper, FilterHelper],

  data() {
    return {
      activeTab: "unmapped",
      search_string: "",
      page: 1,
      pageSize: 25,
      loading: false,
      showMapDialog: false,
      selectedRecord: null,
      payorsLoading: false,
      saving: false,
      formData: {
        insurance_name: "",
        mapped_insurance_name: "",
        carrier_code: "",
        waveland_verification_code: "",
        approved_by: "",
      },
    }
  },

  computed: {
    ...mapGetters("emrInsurances", [
      "getEMRInsurances",
      "getUpdateEMRInsuranceStatus",
      "getRemoveEMRInsuranceStatus",
    ]),
    ...mapGetters("payors", ["getAllPayors"]),
  },

  mounted() {
    this.fetchRecords()
  },

  methods: {
    onTabChange() {
      this.page = 1
      this.search_string = ""
      this.fetchRecords()
    },

    onSearch() {
      setTimeout(() => {
        this.page = 1
        this.fetchRecords()
      }, 600)
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.page = 1
      this.fetchRecords()
    },

    handleCurrentChange(page) {
      this.page = page
      this.fetchRecords()
    },

    async fetchRecords() {
      try {
        this.loading = true
        const params = {
          page: this.page,
          limit: this.pageSize,
          is_not_mapped: this.activeTab === "unmapped",
          status: "ACTIVE"
        }
        if (this.search_string) {
          params.search_string = this.search_string
        }
        await this.$store.dispatch("emrInsurances/fetchEMRInsurances", params)
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },

    openMapDialog(record) {
      this.selectedRecord = record
      this.formData = {
        insurance_name: record.insurance_name || "",
        mapped_insurance_name: record.mapped_insurance_name || "",
        carrier_code: record.carrier_code || "",
        waveland_verification_code: record.waveland_verification_code || "",
        approved_by: record.approved_by?._id || record.approved_by || this.getAuthenticatedUser?._id || "",
      }
      if (record.mapped_insurance_name) {
        this.$store.dispatch("payors/fetchAllPayors", {
          search_string: record.mapped_insurance_name,
          page: 1,
          limit: 10,
          status: "ACTIVE",
        })
      }
      this.showMapDialog = true
    },

    async searchPayors(query) {
      if (query && query.length > 1) {
        this.payorsLoading = true
        await this.$store.dispatch("payors/fetchAllPayors", {
          search_string: query,
          page: 1,
          limit: 20,
          status: "ACTIVE",
        })
        this.payorsLoading = false
      }
    },

    onPayorSelect(name) {
      const payors = this.getAllPayors?.data || []
      const matched = payors.find((p) => p.name === name)
      if (matched) {
        this.formData.carrier_code = matched.payor_electronic_id || ""
      }
    },

    resetForm() {
      this.selectedRecord = null
      this.formData = {
        insurance_name: "",
        mapped_insurance_name: "",
        carrier_code: "",
        waveland_verification_code: "",
        approved_by: this.getAuthenticatedUser?._id || "",
      }
    },

    async saveMapping() {
      if (!this.selectedRecord) return
      try {
        this.saving = true
        const payload = {
          mapped_insurance_name: this.formData.mapped_insurance_name,
          carrier_code: this.formData.carrier_code,
          waveland_verification_code: this.formData.waveland_verification_code,
          approved_by: this.formData.approved_by,
          is_not_mapped: false,
        }
        await this.$store.dispatch("emrInsurances/updateEMRInsurance", {
          id: this.selectedRecord._id,
          data: payload,
        })
        if (this.getUpdateEMRInsuranceStatus) {
          successNotification("Insurance mapped successfully")
          this.showMapDialog = false
          this.fetchRecords()
        } else {
          errorNotification("Error saving insurance mapping")
        }
      } catch (err) {
        console.error(err)
        errorNotification("Error saving insurance mapping")
      } finally {
        this.saving = false
      }
    },

    async deleteRecord(id) {
      try {
        this.loading = true
        await this.$store.dispatch("emrInsurances/removeEMRInsurance", id)
        if (this.getRemoveEMRInsuranceStatus) {
          successNotification("Record deleted successfully")
          this.fetchRecords()
        } else {
          errorNotification("Error deleting record")
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss"></style>
